export default __webpack_public_path__ + "static/media/background.b27ad8ba.mp3";